import PropTypes from "prop-types";
import React, { useState } from "react";

import GroupSelectListPage from "../../../../../containers/administrative/grupos/group-select-list-page";
import { language } from "../../../../../language";
import Provider from "../../../../../Provider";
import GenericModal from "../../../../modal-closebtn/index";

const ModelerModalGroupList = ({ FormComponents, saveGroup, element }) => {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = (value) => {
    const saveObject = {};
    if (value && value.length > 0) {
      value.forEach(function (element) {
        saveObject[element] = true;
      });
    }

    saveGroup(element, Object.keys(saveObject).length > 0 ? saveObject : false);
  };

  const onchangeGroupSelect = (value) => {
    handleSave([...value.ids]);
  };

  return (
    <Provider>
      <GenericModal
        title={language.listGroupMenu}
        handleClose={handleClose}
        size="xl"
        bigHeight
        open={open}
      >
        <GroupSelectListPage
          onchangeGroupSelect={onchangeGroupSelect}
          selectedgroups={FormComponents}
        />
      </GenericModal>
    </Provider>
  );
};

ModelerModalGroupList.propTypes = {
  FormComponents: PropTypes.any,
  theme: PropTypes.object,
  saveGroup: PropTypes.func,
  element: PropTypes.object,
};

export default ModelerModalGroupList;
